import { ModalActionTypes } from '@acorns/web-components'
import { object, string } from 'yup'

import { noSpecialCharacters } from 'utils/validationSchema'
import { transformErrors } from 'utils/errors'

noSpecialCharacters()

// Validation messages
const addressError = 'Please enter a valid address.'
const poBoxRegex =
  /^(?!.*(?:(.*((p|post)[-.\s]*(o|off|office)[-.\s]*(box|bin)[-.\s]*)|.*((p |post)[-.\s]*(box|bin)[-.\s]*)))).*$/i
const poBoxError = 'P.O. Box is not supported.'
const cityError = 'Please enter a valid city.'
const stateError = 'Please enter a valid state.'
const zipCodeError = 'Please enter a valid zip code.'

export const ZIP_CODE_LENGTH = 5

export const validationSchema = object().shape({
  address1: string()
    .required(addressError)
    .matches(poBoxRegex, poBoxError)
    .excludeSpecialCharacters(),
  address2: string().ensure().matches(poBoxRegex, poBoxError).excludeSpecialCharacters(),
  city: string().required(cityError).excludeSpecialCharacters(),
  state: string().required(stateError),
  zip: string()
    .required(zipCodeError)
    .min(ZIP_CODE_LENGTH, zipCodeError)
    .max(ZIP_CODE_LENGTH, zipCodeError),
})

export const validate = (values) => {
  let errors = {}

  try {
    validationSchema.validateSync(values, { abortEarly: false })
  } catch (validationErrors) {
    errors = transformErrors(validationErrors.inner)
  }

  return errors
}

export const noPOBoxErrorModal = (props) => ({
  title: 'Error',
  message: 'PO Box is not allowed for an investment account. Please try again!',
  actions: [
    {
      type: ModalActionTypes.primary,
      label: 'Okay',
      handler: props.closeErrorModal,
    },
  ],
})
